import { render, staticRenderFns } from "./Multicheckbox.vue?vue&type=template&id=4c988cd5"
import script from "./multicheckbox.ts?vue&type=script&lang=js&external"
export * from "./multicheckbox.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports